import React, { useState, useEffect } from 'react';
import Loading from 'src/components/Loading';
import { isJobIncomplete, isJobSuccess } from 'src/reducers/JobStatus';
import { MAX_POLLING_INTERVAL, INITIAL_POLLING_INTERVAL } from 'src/constants/Generals';
import Button from 'jbc-front/components/Button';
import BonusReportsCreateModalContainer from '../containers/BonusReportsCreateModalContainer';
import BonusReportsDownloadModalContainer from '../containers/BonusReportsDownloadModalContainer';
import styles from './DownloadBonusReports.scss';
import { useTranslation } from 'react-i18next';

function DownloadBonusReports(props) {
  const [isCreateModalOpen, setCreateModalOpen] = useState(false);
  const [isDownloadModalOpen, setDownloadModalOpen] = useState(false);
  const clientBonusId = props.clientBonusId;
  const { t, i18n } = useTranslation();

  // 初回にclient bonus idがある場合に1度だけ実行
  // fetchClientBonusReportCreationStatusの先でstate変更しているため副作用あり
  useEffect(() => {
    const { bonusPage, setLoaded, fetchClientBonusReportCreationStatus } = props;
    (async () => {
      if (clientBonusId) {
        if (!bonusPage.isLoaded) {
          fetchClientBonusReportCreationStatus(clientBonusId);
          setLoaded();
        }
      }
    })();
  }, []);

  useEffect(
    () => {
      const { fetchClientBonusReportCreationStatus } = props;
      const pollFetchClientBonusReportCreationStatusIfCreating = async (interval, bonusId) => {
        let newInterval = interval;

        if (isJobIncomplete(props.jobStatus.status) === true) {
          if (interval < MAX_POLLING_INTERVAL) {
            newInterval *= 2;
          }
          setTimeout(() => {
            fetchClientBonusReportCreationStatus(bonusId);
            pollFetchClientBonusReportCreationStatusIfCreating(interval, bonusId);
          }, newInterval);
        }
      };

      pollFetchClientBonusReportCreationStatusIfCreating(INITIAL_POLLING_INTERVAL, clientBonusId).then();
    },
    [props.jobStatus.status]
  );

  // 条件に応じてrenderするdomを変える
  // ページ遷移して戻ってきた場合などでも作成中の表示を出す
  // 賞与確定がされていなかったり解除されたりで未確定の状態では、作成中や作成完了には流れないようにする

  // 作成中
  if (isJobIncomplete(props.jobStatus.status) === true) {
    return (
      <div className={styles.loading}>
        <Button primary widthWide disabled icon={<Loading />}>
          {t('features.EmployeeBonus.components.DownloadBonusReports.creating_data')}
        </Button>
      </div>
    );
  }

  // 作成完了
  if (isJobSuccess(props.jobStatus.status) === true) {
    return (
      <React.Fragment>
        <div className={styles.button}>
          <Button onClick={() => setDownloadModalOpen(true)} primary widthWide>
            {t('features.EmployeeBonus.components.DownloadBonusReports.statement_batch_export')}
          </Button>
        </div>
        <BonusReportsDownloadModalContainer
          isOpen={isDownloadModalOpen}
          hideModal={() => setDownloadModalOpen(false)}
          clientBonusId={props.clientBonusId}
        />
      </React.Fragment>
    );
  }

  // 作成
  return (
    <React.Fragment>
      <div className={styles.button}>
        <Button disabled={!props.isConfirmed} onClick={() => setCreateModalOpen(true)} primary widthWide>
          {t('features.EmployeeBonus.components.DownloadBonusReports.statement_batch_creation')}
        </Button>
      </div>
      <BonusReportsCreateModalContainer
        isOpen={isCreateModalOpen}
        hideModal={() => setCreateModalOpen(false)}
        clientBonusId={props.clientBonusId}
      />
    </React.Fragment>
  );
}
export default DownloadBonusReports;
